import { Outlet, createRootRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { InAppBanner } from '../components/in-app-banner/InAppBanner';
import { Spinner, ToastProvider } from '../components/ui';
import { NotFoundPage } from './NotFoundPage';

/** Root route: no chrome (features choose AppShell or full-screen layouts). */
export const rootRoute = createRootRoute({
  component: () => (
    <ToastProvider>
      {/* in-app browsers (KakaoTalk, Zalo…): "open in your browser" banner, in flow above the page */}
      <InAppBanner />
      <Suspense
        fallback={
          <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
            <Spinner />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </ToastProvider>
  ),
  notFoundComponent: NotFoundPage,
});
